import { Grid } from '@material-ui/core';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import BaseButton from 'src/common/components/base-button';
import { convertCurrency } from 'src/common/helpers/currency-helper';
import { ITender } from 'src/common/interfaces/dtos/ITender';
import { IButton } from 'src/common/interfaces/IButton';
import { AppState } from 'src/common/redux/configure-store';
import { ReturnsType } from 'src/transaction-search/interfaces/get-effective-return-policy-response';
import { styles } from './tender-refund-message-styles';

export interface TenderAmountMessageProps {
  amount: number;
  refundTender: ITender[];
}

// TODO: make this re-useable and put it somewhere better

export const TenderAmountMessage = (props: TenderAmountMessageProps): JSX.Element => {
  const classes = styles();
  const { amount, refundTender } = props;
  const isTBRTransaction = useSelector(
    (state: AppState): boolean =>
      state.posMode.returnMode.returnType === ReturnsType.TransactionBasedReturn,
  );
  return refundTender.length > 1 && isTBRTransaction ? (
    <Grid direction='column' container>
      {refundTender.map((tender, index) => {
        return (
          <Grid
            data-testid='recommended-refund-tender-list'
            justifyContent='center'
            className={classes.flexDisplay}
            key={index}
            item
          >
            <Grid
              data-testid='recommended-tender-refund-amount'
              className={`${classes.currency} ${classes.amountAlignment}`}
              xs={6}
            >
              {tender.amount ? convertCurrency(tender.amount) : ''}
            </Grid>
            <Grid
              xs={6}
              data-testid='recommended-tender-refund-message'
              className={classes.descriptionAlignment}
            >
              {tender.description}
            </Grid>
          </Grid>
        );
      })}
    </Grid>
  ) : (
    <Grid direction='column' container>
      <Grid data-testid='recommended-tender-refund-amount' className={classes.currency} item>
        {amount ? convertCurrency(Math.abs(amount)) : ''}
      </Grid>
      <Grid data-testid='recommended-tender-refund-message' item>
        {refundTender[0].description}
      </Grid>
    </Grid>
  );
};

export const getTenderAmountMessage = (props: TenderAmountMessageProps) => {
  return <TenderAmountMessage {...props} key={1} />;
};

export interface TriButtonModalBottomProps {
  closeButton: IButton;
  middleButton: IButton;
  rightButton: IButton;
}

export const getTriButtonModalBottom = (props: TriButtonModalBottomProps) => {
  return <TriButtonModalBottom {...props} />;
};

// TODO: make this re-useable and put it somewhere better

export const TriButtonModalBottom = ({
  closeButton,
  middleButton,
  rightButton,
}: TriButtonModalBottomProps): JSX.Element => {
  const classes = styles();
  const { t } = useTranslation();

  return (
    <Grid className={classes.container} container justifyContent='space-between'>
      <Grid item container alignItems='center' justifyContent='flex-start' xs={3}>
        <BaseButton
          className={classes.closeButton}
          buttonType='white'
          data-testid='tri-button-modal-1'
          onClick={() => closeButton.onClick()}
        >
          {typeof closeButton.label === 'string' ? t(closeButton.label) : closeButton.label}
        </BaseButton>
      </Grid>
      <Grid item container alignItems='center' justifyContent='flex-end' xs={9}>
        <BaseButton
          className={classes.rightButton}
          data-testid='tri-button-modal-2'
          onClick={() => middleButton.onClick()}
          buttonType={middleButton.buttonType}
        >
          {typeof middleButton.label === 'string' ? t(middleButton.label) : middleButton.label}
        </BaseButton>
        <BaseButton
          className={classes.rightButton}
          data-testid='tri-button-modal-3'
          onClick={() => rightButton.onClick()}
          disabled={rightButton.disabled}
          buttonType={rightButton.buttonType}
        >
          {typeof rightButton.label === 'string' ? t(rightButton.label) : rightButton.label}
        </BaseButton>
      </Grid>
    </Grid>
  );
};
